import { Link } from 'react-router-dom';
import { Rocket, ArrowRight } from 'lucide-react';
import { useStore } from '../../api/stores';

/**
 * Persistent reminder that setup isn't finished. The onboarding wizard only
 * flips `isLive` to true on its final "Go to dashboard" step, so a store that
 * reaches the dashboard while still `isLive === false` skipped or abandoned
 * onboarding. Shown on every authenticated page (the wizard route lives
 * outside AppShell, so it never shows there).
 */
export function OnboardingBanner() {
  const { data: store } = useStore();

  if (!store || store.isLive) return null;

  return (
    <div className="border-b border-accent/30 bg-accent-light">
      <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-2.5 sm:flex-row sm:items-center sm:justify-between md:px-8">
        <div className="flex items-center gap-2.5 text-sm">
          <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-accent/15 text-accent">
            <Rocket className="h-4 w-4" />
          </span>
          <span className="text-primary">
            <span className="font-semibold">Your store isn&apos;t live yet.</span>{' '}
            <span className="text-mid">Finish setup to start selling.</span>
          </span>
        </div>
        <Link
          to="/onboarding"
          className="inline-flex shrink-0 items-center gap-1.5 self-start rounded-[8px] bg-accent px-3 py-1.5 text-sm font-medium text-white transition-colors hover:bg-accent-hover sm:self-auto"
        >
          Finish setup
          <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
}
